export default __webpack_public_path__ + "static/media/service-report.5d2f315f.png";